import { VolumeDriverApi } from '@app/services/volume-driver-service/volume-driver.service';
import { DEFAULT_PAGINATION_PAGE_LIMIT } from '@app/shared/components/AppTablePagination/consts';
import { enqueSnackAction } from '@app/store/snacks';
import { call, put } from 'redux-saga/effects';
import {
  deleteVolumeSystemConfigurationsAction,
  fetchVolumeDriverConfigurationsDataAction,
  setVolumeDriverConfigurationsLoadingAction,
} from '../actions';

export function* deleteVolumeSystemConfigurationsSaga(
  action: ReturnType<typeof deleteVolumeSystemConfigurationsAction>
) {
  try {
    yield put(setVolumeDriverConfigurationsLoadingAction({ loading: true }));

    yield call(VolumeDriverApi.deleteVolumeSystemConfigurations, {
      ids: action.ids,
    });
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Selected volume system configurations has been deleted.',
          options: {
            variant: 'success',
          },
          key: 'volume-system-configuration-delete-success',
        },
      })
    );
    yield put(
      fetchVolumeDriverConfigurationsDataAction({
        skip: 0,
        limit: DEFAULT_PAGINATION_PAGE_LIMIT,
      })
    );
  } catch (e) {
    console.log('Failed to delete volume system configurations', e.message);

    if (e.response && e.response.status === 409) {
      yield put(
        enqueSnackAction({
          notification: {
            message:
              'Failed to delete,check your selection.Some items might be used on Volume Driver Allocation.',
            options: {
              variant: 'warning',
            },
            key: 'volume-system-configuration-delete-failed',
          },
        })
      );
    } else {
      yield put(
        enqueSnackAction({
          notification: {
            message: 'Failed to delete, try again later.',
            options: {
              variant: 'error',
            },
            key: 'volume-system-configuration-delete-failed',
          },
        })
      );
    }

    yield put(setVolumeDriverConfigurationsLoadingAction({ loading: false }));
  }
}
